//src/utils/dateUtils.js
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays } from 'date-fns';

/**
 * Calcula o intervalo de datas visíveis para a agenda com base no modo de visualização.
 * @param {string} viewMode - O modo de visualização ('mensal', 'semanal', 'quinzenal').
 * @param {Date} selectedDate - A data atualmente selecionada.
 * @returns {{firstDayVisible: Date, lastDayVisible: Date}} - O primeiro e o último dia visíveis.
 */
export const getVisibleDateRange = (viewMode, selectedDate) => {
    const firstDay = startOfWeek(viewMode === 'mensal' ? startOfMonth(selectedDate) : selectedDate, { weekStartsOn: 0 });
    let lastDay;

    if (viewMode === 'semanal') {
        lastDay = endOfWeek(firstDay, { weekStartsOn: 0 });
    } else if (viewMode === 'quinzenal') {
        lastDay = addDays(firstDay, 13);
    } else {
        // 'mensal' é o padrão
        lastDay = endOfWeek(endOfMonth(selectedDate), { weekStartsOn: 0 });
    }

    return { firstDayVisible: firstDay, lastDayVisible: lastDay };
};
